import React, { useState } from "react";
import { withTranslation, Trans } from "react-i18next";
import Popover from "@material-ui/core/Popover";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import { getAllLanguages, getAllLanguagesWithGlobal } from "../../../helper/module";
import { connect } from "react-redux";
import { get_cssFlag, get_lang, set_direction, set_lang ,set_cssFlag, set_country} from "../../../helper/UserData/userdate";
import styled from "styled-components";

const Title = styled.span`
  border-bottom: ${ (props) => props.selected ? `4px solid ${global.config.colors.primary}` : "unset"};
  color: ${(props) => props.selected ?  `${global.config.colors.primary}` : "#242424"};
`;

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
    };
  }

  handleClick = (event) => {
    this.setState({
      anchorEl: event.currentTarget,
    });
  };

  handleClose = () => {
    this.setState({
      anchorEl: null,
    });
  };

  changeLanguage = (lang) => {
    this.props.dispatch({
      type: "changeDirection",
      direction: lang.direction,
      language: lang.lang,
    });
    set_lang(lang.lang);
    set_direction(lang.direction);
    set_cssFlag(lang.cssFlag)
    set_country(lang.country)
    this.props.i18n.changeLanguage(lang.lang);
    this.handleClose()
  };

  render() {
    const open = Boolean(this.state.anchorEl);
    const id = open ? "simple-popover" : undefined;

    return (
      <div className="SecondSectionHeader">
        <Title className={`LoginRegisterLogin`}
          selected={this.props.LoginIsActive == false}
          onClick={() => {
            this.props.changeLogin(false);
          }}
          >
        <Trans i18nKey={"login"}> </Trans>{" "}
        </Title>


        {(global.config.isIndividualSignupActive || global.config.isBusinessSignupActive) && <Title className={`LoginRegisterLogin `}
          selected={this.props.LoginIsActive == true}
          onClick={() => {
            this.props.changeLogin(true);
          }}
          >
        <Trans i18nKey={"Register"}> </Trans>{" "}
        </Title>}
        {/* <span
          onClick={this.handleClick}
          className={`headerLanguagelabel ${get_cssFlag()}`}
        >
          {" "}
          <Trans i18nKey={get_lang()}> </Trans>{" "}
        </span>
        <Popover
          id={id}
          open={open}
          anchorEl={this.state.anchorEl}
          onClose={this.handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          <List>
            {getAllLanguagesWithGlobal(global.config.availableLanguages).map((lang) => {
              return (
                <ListItem
                  onClick={() => {
                    this.changeLanguage(lang);
                  }}
                >
                  <span className={`headerLanguagelabelItem ${lang.cssFlag}`}>
                    {" "}
                    <Trans i18nKey={lang.i18Lang}> </Trans>{" "}
                  </span>
                </ListItem>
              );
            })}
          </List>
        </Popover> */}
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  authenticated: state.SharedData.access_token,
  direction: state.SharedData.direction,
});
const mapDispatchToProps = (dispatch) => ({
  dispatch: dispatch,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(App));
